import App from "@frog/source/models/App.js"
import Audiomix from "@frog/source/juice/Audiomix.js"

import encounters from "@frog/source/data/encounters/encounters.js"
// import tests from "@frog/source/tests/_.js" // TODO: lazy load this and all other imports to this file
import Director from "@frog/source/juice/Director.js"

class UserError extends Error {}

const Navigation = new class {
    constructor() {
        this.routes = []
        this.state = {"screen": "SplashScreen"}
    }
    go(path) {
        // this.state = state
        // TODO: Make this change the url & url history
        window.location.hash = path
        // TODO: is there anyway for us to directly call load from here
        // without an infinite loop of setting and refreshing but also
        // preserving the existing state we already have but also allowing
        // to default the state for true niave url loads?
    }
    goBack() {
        window.location.hash = ""
    }
    load(path) {
        path = path[0] == "#" ? path.substring(1) : path
        // path = "/" + path
        // console.log("Routing", path)
        this.request = {
            "path": path,
        }
        for(let index in this.routes) {
            const route = this.routes[index]
            // console.log(request.path, "->", route.path)
            if(this.request.path.match(route.path)) {
                try {
                    const state = route.func(this.request)
                    if(state != undefined) {
                        return this.state = state
                    }
                } catch(error) {
                    this.request.error = error

                    if(error instanceof UserError) {
                        this.state = this.onUserError(this.request)
                    } else { // if(error instanceof Error) {
                        this.state = this.onError(this.request)
                    }

                    throw error
                }
            }
        }
    }
    on(path, func) {
        if(path instanceof Error) {
            this.routes[path] = {path, func}
            return
        }
        if(path instanceof RegExp != true) {
            path = path.replace(/\*/g, "(.*)")
            path = new RegExp("^" + path + "$", "i")
        }
        this.routes.push({path, func})
    }
}

export default Navigation

Navigation.on("/", function(request) {
    return {"screen": "SplashScreen"}
    // TODO: if first time, play animations for splashing
})

Navigation.on("/credits", function(request) {
    return {"screen": "CreditsScreen"}
})

Navigation.on("/game", function(request) {
    window.setTimeout(() => {
        Audiomix.trigger("Music:1")
    }, 32 * 4)
    return {"screen": "TitleScreen"}
})

Navigation.on("/game/encounters/*", function(request) {
    const slug = request.path.split("/").pop() // TODO: support RegExp wildcards??

    if(App.game == undefined) {
        // console.log("Creating game")
        App.load({
            "game": {
                "encounter": {}
            },
        })
        // TODO: Move this into an express-style middleware!!
    }
    if(encounters[slug] == undefined) {
        throw new UserError("Could not find encounter " + slug)
    }

    // TODO: Load this dev state from your friendly json payload.
    // const app = require("@frog/source/data/devstate.js")

    //if(App.game.encounter == undefined || App.game.encounter.slug != slug) {
    // console.log("Creating encounter", slug)
    App.load({
        "game": {
            "encounter": encounters[slug]
            // TODO: let references be
        }
    })
    // App.game.encounter = CombatEncounter.load(encounters[slug])

    return {"screen": "EncounterScreen"}
})

Navigation.on("/*", function(request) {
    throw new UserError("Could not find " + request.path)
})

Navigation.onUserError = function(request) {
    return {"screen": "ErrorScreen", "message": request.error.message}
}
Navigation.onError = function(request) {
    return {"screen": "ErrorScreen", "message": "Something went wrong!!"}
}

if(typeof window != "undefined") {
    window.setTimeout(() => {
        Navigation.load(window.location.hash)
    })
    window.addEventListener("hashchange", () => {
        Navigation.load(window.location.hash)
    })
}

// SPLASH SCREEN

// // TODO: centralize this along with the view navigation
// // const isExplicitlyTesting = params.get("test") != null
// // if(isExplicitlyTesting == true) {
// //     window.frog.test.log()
// // }
// window.frog.test.log()
// window.frog.navigation = {"screen": "TestListScreen"}
